import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import mixpanel from "mixpanel-browser";
import { isPWA } from "@/libs/hooks/pwa";

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;
const IS_LOCAL = import.meta.env.VITE_APP_ENV === "local";

const initializeMixPanel = () => {
  if (IS_LOCAL) {
    console.log("MixPanel tracking disabled in local environment");
    return false;
  }

  if (!MIXPANEL_TOKEN) {
    console.warn("MixPanel token not found");
    return false;
  }

  if (mixpanel.__loaded) {
    return true;
  }

  try {
    mixpanel.init(MIXPANEL_TOKEN, {
      debug: IS_LOCAL,
      track_pageview: "full-url",
      persistence: "localStorage",
    });
    return true;
  } catch (error) {
    console.error("MixPanel initialization error:", error);
    return false;
  }
};

const updateMixPanelUser = (user) => {
  if (!user) {
    mixpanel.reset();
    return;
  }

  try {
    mixpanel.identify(user.uid);
    mixpanel.people.set({
      distinct_id: user.uid,
      email: user.email,
      name: user.displayName,
      phone: user.phoneNumber,
      uid: user.uid,
      providerId: user.providerId,
    });
    if (isPWA) {
      mixpanel.people.set({
        isPWA: true,
      });
    }
  } catch (error) {
    console.error("MixPanel user update error:", error);
  }
};

export const useMixPanel = (auth) => {
  useEffect(() => {
    if (!initializeMixPanel()) {
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, updateMixPanelUser);
    return () => unsubscribe();
  }, [auth]);
};
